import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });

/**
* Sentry permet de capturer les erreurs, ici en javascript, qui remonte dans les navigateurs
* des clients.
*/
import * as Sentry from "@sentry/browser";

// Définition de l'environnement pour Sentry
const environment = (() => {
    const host = window.location.host;

    if (host.includes('sitetest.pcsoft.com')) return 'staging';
    else if (host.includes('pcsoft.com')) return 'local';
    return 'production';
})();

// On initialise Sentry uniquement si l'environnement est production ou staging (serveur de test)
if(environment === 'production' || environment === 'staging') {
    Sentry.init({
        dsn: "https://030315ea58b844329023131fbf84d02d@sentry.pcsoft.fr/3",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        initialScope: {
            tags: {
                "scope": "frontend",
                "framework": "vanilla-js"
            },
        },
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        // Filter out errors from browser extensions (chrome, firefox, safari)
        denyUrls: [
            /^chrome-extension:\/\//,
            /^moz-extension:\/\//,
            /^safari-extension:\/\//,
            /^webkit-masked-url:\/\//,
        ],
        environment: environment
    });
}


/*
 | Importation des polufill pour le fonctionnement sur des navigateurs plus anciens (type iE 1&)
 */
// import 'formdata-polyfill' // C'était pour IE ?

/**
 * Déclaration de l'objet de gestion de cookies de manière globale
 * Normalement déjà géré par le inject() plugin dans la configuration vite
 */
import Cookies from "js-cookie";
window.Cookies = Cookies


/**
 * L'utilitaire PageParametre permet de récupérer des informations dans l'URL
 * passé à la page pour les injecter par exemple dans les formulaires
 */

import { PageParametre } from "./utils/FuncPageParametre";
window.PageParametre = PageParametre // PageParamètre fonction

/**
 * L'utilisateir FollowParam permet de faire suivre les informations d'un lien vers un autre lien
 * Il n'est plus censé être injecté dans le DOM car il est remplacé par une classe utilitaire
 */

import { FollowParam } from "./utils/FuncFollowParam";
window.FollowParam = FollowParam // FollowParam fonction

/**
 * Cette utilitaire permet de faire suivre les informations contenu dans la balise p= dans un cookie
 * puis est ensuite restauré dans un les inputs de type CODEPUB.
 * Devrait à terme disparaitre poru être géré directement depuis le module FORM qui est capable
 * de restaurer des informations depuis les cookies
 */
import { KeepAd } from "./utils/FuncAd";
KeepAd()

/**
 | Injection de la librairie JQuery dans l'objet window (LM: 26/11/2020)
 | Dans l'attente de la dépréciation de JQuery sur le site, je l'ajoute dans le node_modules pour ne pas qu'il traine partout.
 | @todo Déprécider JQuery quand les librairies seront re-écrite
 */
import 'jquery'


/*
 | Cette partie permet d'importer les éléments javascript du coeur de l'application
 */
// import './core/ShouldCatchErrors'
import './core/Ancre'
import './core/FollowParams';
import "./core/EmailModal"
import "./core/ResponsiveSlides"
import "./core/FormCookies"
import "./core/PageParametres"
import "./core/OP1EuroV2"

/*
 | Cette partie sert à charger les composants javascript utiles au fonctionnement du site.
 */
import "./components/Fancybox"
import "./components/swiper/Swiper"
